exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hasOverdueRow {\n  color: red !important;\n}\n", ""]);

// exports
